import { FC, useEffect, useRef, useState } from "react";

import "./DynamicScroll.scss";

type DynamicScrollProps = {
  maxHeightBeforeScroll: number;
  children: React.ReactNode;
  className?: string;
};

const DynamicScroll: FC<DynamicScrollProps> = function (props) {
  const { children, className = "", maxHeightBeforeScroll } = props;
  const containerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  // Function to adjust the scrollability based on the content size
  const adjustScrollability = () => {
    const container: any = containerRef.current;
    if (!container) return;

    const contentHeight = container.scrollHeight;
    const maxHeight = window.innerHeight * Math.abs(maxHeightBeforeScroll / 100);

    // If content exceeds max-height, enable scroll, else disable it
    if (contentHeight > maxHeight) {
      setIsScrollable(true);
    } else {
      setIsScrollable(false);
    }
  };

  // Adjust scrollability when the component mounts or children change
  useEffect(() => {
    adjustScrollability();

    // Optionally, add a resize event listener to handle window resizing
    window.addEventListener("resize", adjustScrollability);

    return () => {
      window.removeEventListener("resize", adjustScrollability);
    };
  }, [children]);

  return (
    <div
      className={`${className} ${isScrollable ? "dynamic-scroll" : ""}`}
      ref={containerRef}
      style={{ ...(isScrollable && { maxHeight: `${maxHeightBeforeScroll}vh` }) }}
    >
      {children}
    </div>
  );
};

export default DynamicScroll;

DynamicScroll.defaultProps = {
  className: "",
};
